var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainBox",attrs:{"id":"app"}},[_c('header',[_c('TheHeader')],1),_c('div',{staticClass:"mainWrapper"},[_c('router-view',{key:_vm.$route.path})],1),_c('footer',[_c('TheFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }